import {getRoutes} from '../../services/ClientService.js';
import {updatePriorityForRoutes} from '../../services/RouteService';
import {getRouteTopics, saveNewRoute, updateRouteTopics, updateRouteDetails, addNewRouteTopics, deleteTopicFromRoute} from '../../services/EditorService.js';

export default {
  namespaced: true,
  state: {
    routesList: [],
    currentRoute: {path: []},
    currentRouteAlt: {alt_path: []},
    vertexToRemove: null,
    vertexToRemoveAlt: null,
    initialTopics: [],
    routeTopics: [],
    initialPath: [],
    initialPathAlt: [],
    initialRouteSettings: {},
    initialRouteSettingsAlt: {},
    updateCheck: false,
    updateCheckAlt: false,
    removedTopics: [],
    removedTopicsAlt: [],
    enableTourLanCheck: false,
    checkFileAnotherTours: false
  },
  getters: {
    routesList: (state) => {
      return state.routesList;
    },
    currentRoute: (state) => {
      return state.currentRoute;
    },
    currentRouteAlt: (state) => {
      return state.currentRouteAlt;
    },
    initialTopics: (state) => {
      return state.initialTopics;
    },
    vertexToRemove: (state) => {
      return state.vertexToRemove;
    },
    vertexToRemoveAlt: (state) => {
      return state.vertexToRemoveAlt;
    },
    routeTopics: (state) => {
      return state.routeTopics;
    },
    removedTopics: (state) => {
      return state.removedTopics;
    },
    removedTopicsAlt: (state) => {
      return state.removedTopicsAlt;
    },
    enableTourLanCheck: (state) => {
      return state.enableTourLanCheck;
    },
    checkFileAnotherTours: (state) => {
      return state.checkFileAnotherTours;
    },
    routeChanged: (state) => {
      var changed = false;
      for (var [index, topic] of state.routeTopics.entries()) {
        if (topic.orderInRoute !== state.initialTopics[index].orderInRoute) {
          changed = true;
        }
      }
      if (state.currentRoute.id) {
        if (Object.keys(state.initialPath).length > -1) {
          if (state.updateCheck === true) {
            changed = true;
            state.updateCheck = false;
          }
        }
      }
      if (state.initialTopics.length !== state.routeTopics.length) {
        changed = true;
      }
      return changed;
    },
    routeChangedAlt: (state) => {
      var changedAlt = false;
      for (var [index, topic] of state.routeTopics.entries()) {
        if (topic.orderInRoute !== state.initialTopics[index].orderInRoute) {
          changedAlt = true;
        }
      }
      if (state.currentRouteAlt.id) {
        if (Object.keys(state.initialPath).length > -1) {
          if (state.updateCheckAlt === true) {
            changedAlt = true;
            state.updateCheckAlt = false;
          }
        }
      }
      if (state.initialTopics.length !== state.routeTopics.length) {
        changedAlt = true;
      }
      return changedAlt;
    },
    routeSettingsChanged: (state) => {
      let edited = false;
      for (let [key, value] of Object.entries(state.initialRouteSettings)) {
        let currentValue = state.currentRoute[key];
        if (typeof value === 'number' && typeof currentValue !== 'number') {
          currentValue = parseInt(currentValue);
        }
        if (currentValue !== value) {
          edited = true;
        }
      }
      return edited;
    },
    routePaths: (state) => {
      return state.routesList;
    },
    routesListLength: (state) => {
      return state.routesList.length;
    },
    updateCheck: (state) => {
      return state.updateCheck;
    },
    updateCheckAlt: (state) => {
      return state.updateCheckAlt;
    },
    pathHasPoints: (state) => {
      if (state.currentRoute.path) {
        return (state.currentRoute.path.length !== 0);
      } else {
        return false;
      }
    },
    pathHasPointsAlt: (state) => {
      if (state.currentRouteAlt.alt_path) {
        return (state.currentRouteAlt.alt_path.length !== 0);
      } else {
        return false;
      }
    }
  },
  mutations: {
    setRoutesList (state, routes) {
      for (var route of routes) {
        route.hover = false;
        route.mapHover = false;
        if (route.path !== null && route.path !== '') {
          route.path = JSON.parse(route.path);
          if (route.alt_path !== null && route.alt_path !== '') {
            route.alt_path = JSON.parse(route.alt_path);
          }
        }
      }
      state.routesList = routes;
    },
    setCurrentRoute (state, route) {
      state.currentRoute = route;
      state.initialPath = Object.assign({}, route.path);
      state.initialRouteSettings = {
        notificationSongId: route.notificationSongId,
        notificationSound: route.notificationSound,
        commentaryDelay: route.commentaryDelay,
        audioControllerNotification: route.audioControllerNotification,
        audioControllerFlashTime: route.audioControllerFlashTime,
        headendSys: route.headendSys
      };
    },
    enableTourLanCheck (state, check) {
      state.enableTourLanCheck = check;
    },
    checkFileAnotherTours (state, check) {
      state.checkFileAnotherTours = check;
    },
    setCurrentRouteAlt (state, route) {
      state.currentRouteAlt = route;
      state.initialPathAlt = Object.assign({}, route.alt_path);
      state.initialRouteSettingsAlt = {
        notificationSongId: route.notificationSongId,
        notificationSound: route.notificationSound,
        commentaryDelay: route.commentaryDelay,
        audioControllerNotification: route.audioControllerNotification,
        audioControllerFlashTime: route.audioControllerFlashTime,
        headendSys: route.headendSys
      };
    },
    setVertex (state, index) {
      state.vertexToRemove = index;
    },
    setVertexAlt (state, index) {
      state.vertexToRemoveAlt = index;
    },
    setInitialRouteSettings (state, route) {
      state.initialRouteSettings = {
        notificationSongId: route.notificationSongId,
        notificationSound: route.notificationSound,
        commentaryDelay: route.commentaryDelay,
        audioControllerNotification: route.audioControllerNotification,
        audioControllerFlashTime: route.audioControllerFlashTime,
        headendSys: route.headendSys
      };
    },
    setRouteTopics (state, topics) {
      for (var topic of topics) {
        topic.hover = false;
        topic.mapHover = false;
      }
      state.initialTopics = topics;
      state.routeTopics = topics;
    },
    removeRouteTopicsFromState (state, index) {
      var topics = state.routeTopics;
      for (var topic of topics) {
        topic.hover = false;
        topic.mapHover = false;
        if (topic.orderInRoute > topics[index].orderInRoute) {
          topic.orderInRoute--;
        }
      }
      if (index === 0) {
        topics = topics.slice(1);
      } else if (index === topics.length - 1) {
        topics = topics.slice(0, topics.length - 1);
      } else {
        topics = topics.slice(0, index).concat(topics.slice(index + 1));
      }
      state.routeTopics = topics;
    },
    removeRouteTopicsFromStateAlt (state, index) {
      var topics = state.routeTopics;
      for (var topic of topics) {
        topic.hover = false;
        topic.mapHover = false;
        if (topic.orderInRoute > topics[index].orderInRoute) {
          topic.orderInRoute--;
        }
      }
      if (index === 0) {
        topics = topics.slice(1);
      } else if (index === topics.length - 1) {
        topics = topics.slice(0, topics.length - 1);
      } else {
        topics = topics.slice(0, index).concat(topics.slice(index + 1));
      }
      state.routeTopics = topics;
    },
    resetRemovedTopics (state) {
      state.removedTopics = [];
    },
    resetRemovedTopicsAlt (state) {
      state.removedTopicsAlt = [];
    },
    clearRoutesList (state) {
      state.routesList = [];
    },
    updateTopicsOrderInRoute (state, payload) {
      state.routeTopics = payload.topics;
      for (var [index, topic] of state.routeTopics.entries()) {
        topic.orderInRoute = index + 1;
      }
    },
    updateInitialTopics (state, topics) {
      state.initialTopics = topics;
    },
    addRoutesList (state, route) {
      route.path = JSON.parse(route.path);
      route.alt_path = JSON.parse(route.alt_path);
      state.routesList.push(route);
    },
    addCurrentPath (state, routePath) {
      state.currentRoute.path = routePath;
    },
    addCurrentPathAlt (state, routePathAlt) {
      state.currentRouteAlt.alt_path = routePathAlt;
      state.currentRoute.alt_path = routePathAlt;
    },
    setInitialPath (state) {
      state.initialPath = Object.assign({}, state.currentRoute.path);
      state.initialPathAlt = Object.assign({}, state.currentRouteAlt.alt_path);
    },
    clearCurrentRoute (state) {
      state.currentRoute = {path: []};
      state.initialPath = [];
      state.currentRouteAlt = {alt_path: []};
      state.initialPathAlt = [];
      state.routeTopics = [];
    },
    setUpdateCheck (state, bool) {
      state.updateCheck = bool;
    },
    setUpdateCheckAlt (state, bool) {
      state.updateCheckAlt = bool;
    },
    clearRouteTopics (state) {
      state.routeTopics = [];
    },
    eraseCurrentPath (state) {
      state.currentRoute.path = [];
    },
    eraseCurrentPathAlt (state) {
      state.currentRouteAlt.alt_path = [];
    }
  },
  actions: {
    async loadRoutes ({commit}, tourId) {
      const response = await getRoutes(tourId);
      if (response.status === 200) {
        commit('setRoutesList', response.data);
      }
    },
    async changeState ({commit}, data) {
      commit('enableTourLanCheck', data);
    },
    async changeStateForFile ({commit}, data) {
      commit('checkFileAnotherTours', data);
    },
    loadEditorRoute ({commit}, route) {
      commit('setCurrentRoute', route);
      commit('setCurrentRouteAlt', route);
    },
    async loadRouteTopics ({commit, state}) {
      commit('clearRouteTopics');
      const response = await getRouteTopics(state.currentRoute.id);
      if (response.data.success) {
        commit('setRouteTopics', response.data.topics);
      } else {
        console.log(response.data.errors);
      }
    },
    cleanRoutesList ({commit}) {
      commit('clearRoutesList');
    },
    updateTopicOrder ({commit}, payload) {
      commit('updateTopicsOrderInRoute', payload);
    },
    updateInitialTopicList ({commit}, topics) {
      commit('updateInitialTopics', topics);
    },
    addRoutesList ({commit}, route) {
      commit('addRoutesList', route);
    },
    addCurrentPath ({commit}, routePath) {
      commit('addCurrentPath', routePath);
    },
    addCurrentPathAlt ({commit}, routePathAlt) {
      commit('addCurrentPathAlt', routePathAlt);
    },
    async insertNewRoute ({commit}, newRoute) {
      const response = await saveNewRoute(newRoute);
      if (response.data === 2) {
        commit('enableTourLanCheck', true);
      }
      if (response.data === 0) {
        commit('checkFileAnotherTours', true);
      }
      if (response.data.success) {
        newRoute.id = response.data.routeId;
        const responsenew = await getRoutes(newRoute.tourId);
        if (responsenew.status === 200) {
          commit('setRoutesList', responsenew.data);
          commit('setCurrentRoute', newRoute);
        }
      } else {
        console.log(response.data.errors);
      }
    },
    async insertNewRouteTopics ({commit}, payload) {
      const response = await addNewRouteTopics({routeId: payload.route.id, newTopics: payload.newTopics});
      if (response.data.success) {
        commit('setCurrentRoute', payload.route);
      } else {
        console.log(response.data.errors);
      }
    },
    async saveRouteChanges ({commit, state}, payload) {
      const routeTopicResponse = await updateRouteTopics(payload.topicOrder);
      if (routeTopicResponse.status === 200) {
        commit('updateInitialTopics', payload.routeTopics);
      }
      const routeUpdateResponse = await updateRouteDetails(state.currentRoute);
      if (routeUpdateResponse.status === 200) {
        commit('setInitialPath');
        commit('setCurrentRoute', state.currentRoute);
        commit('setCurrentRouteAlt', state.currentRouteAlt);
      }
    },
    clearCurrentRoute ({commit}) {
      commit('clearCurrentRoute');
    },
    setVertex ({commit}, index) {
      commit('setVertex', index);
    },
    setVertexAlt ({commit}, index) {
      commit('setVertexAlt', index);
    },
    setUpdateCheck ({commit}, bool) {
      commit('setUpdateCheck', bool);
    },
    setUpdateCheckAlt ({commit}, bool) {
      commit('setUpdateCheckAlt', bool);
    },
    clearRouteTopics ({commit}) {
      commit('clearRouteTopics');
    },
    killPath ({commit}) {
      commit('eraseCurrentPath');
    },
    killPathAlt ({commit}) {
      commit('eraseCurrentPathAlt');
    },
    async saveRoute ({commit}, route) {
      const response = await updateRouteDetails(route);
      if (response.status === 200) {
        commit('setCurrentRoute', route);
        commit('setCurrentRouteAlt', route);
      }
    },
    async reorderTourRoutes ({commit}, data) {
      const responsen = await updatePriorityForRoutes(data);
      if (responsen.data === 'success') {
        return 'Success';
      }
    },
    async removeRouteTopic ({commit}, ids) {
      deleteTopicFromRoute(ids);
    },
    async removeRouteTopicAlt ({commit}, ids) {
      deleteTopicFromRoute(ids);
    },
    async removeRouteTopicsFromState ({commit}, index) {
      commit('removeRouteTopicsFromState', index);
    },
    async removeRouteTopicsFromStateAlt ({commit}, index) {
      commit('removeRouteTopicsFromStateAlt', index);
    },
    resetRemovedTopicsAlt ({commit}) {
      commit('resetRemovedTopicsAlt');
    },
    resetRemovedTopics ({commit}) {
      commit('resetRemovedTopics');
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/routesModule.js